
export const useCollectionSearchStore = defineStore('collectionSearch', {
  state: () => ({
    collections: [],
    selectedCollection: 'all',
    selectedAirport: '',
    airportName: '',
  }),
  actions: {
    setCollections(collections) {
      this.collections = [
        {
          id: 'all',
          name: 'Search all locations',
        },
        ...collections,
      ];
    },
    setSelectedCollection(collectionId) {
      this.selectedCollection = collectionId;
      this.selectedAirport = '';
    },
    setSelectedAirport(code, name = '') {
      this.selectedAirport = code;
      this.airportName = name;
      this.selectedCollection = 'all';
    },
  },
  getters: {
    query: (state) => {
      const {checkInDateISO, checkOutDateISO } = useCalendarPopover();
      if (state.selectedAirport) {
        return `/search?airport=${encodeURIComponent(state.selectedAirport)}&checkinDate=${checkInDateISO}${checkOutDateISO ? `&checkoutDate=${checkOutDateISO}` : ''}`
      }
      if (state.selectedCollection === 'all') {
        return `/search?facility=${state.selectedCollection}&checkinDate=${checkInDateISO}${checkOutDateISO ? `&checkoutDate=${checkOutDateISO}` : ''}`
      }
      return `/search?collection=${state.selectedCollection}&checkinDate=${checkInDateISO}${checkOutDateISO ? `&checkoutDate=${checkOutDateISO}` : ''}`
    }
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
});
